module.exports = __webpack_public_path__ + "img/img_3.9894e52a.png";